import * as action_types from "./constants";

export type crewYardState = {
  tagData: {
    loader: boolean;
    data: [] | null;
  };
};

const initialState: crewYardState = {
  tagData: {
    loader: true,
    data: null,
  },
};

type MyDataActionType = {
  type: typeof action_types.TAGS_CATEGORIES;
  data: { payload: []; loading: boolean };
};

const myTeamReducer = (
  state = initialState,
  action: MyDataActionType
): crewYardState => {
  const { type, data } = action;
  switch (type) {
    case action_types.TAGS_CATEGORIES:
      return {
        ...state,
        tagData: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
